import React, { lazy, Suspense } from "react";
import { m } from "framer-motion";
import {
  ProtectedEmail,
  ProtectedPhone,
  INAQ_CONTACTS,
} from "../../../utils/ContactObfuscator";

const ParticleSection = lazy(() => import("../../ParticleSection"));
const Buttons = lazy(() => import("../../Button/Buttons"));

const RepeatCTA = ({ cta, onOpenModal }) => (
  <m.section style={{ contentVisibility: "auto", containIntrinsicSize: "0 400px" }}>
    <Suspense
      fallback={<div className='h-[400px] bg-gray-100 animate-pulse rounded-md'></div>}
    >
      <ParticleSection className='particle-section'>
        <div className='mx-auto text-center py-40 sm:py-32 xs:pb-10'>
          <h1 className='font-["Oxanium"] text-center sm:text-5xl lg:text-6xl font-bold !pr-0 mb-6 !text-white relative pointer-events-none'>
            {cta.headline}
          </h1>
          <p className='mt-16 xs:mt-12 mb-8 xs:mb-12 text-base leading-8 md:leading-10 text-gray-300 max-w-3xl mx-auto xs:text-[14px] xs:px-6 pointer-events-none'>
            {cta.body}
          </p>

          <Buttons
            type='button'
            onClick={onOpenModal}
            className='rounded-[2px] bg-white font-normal font-rubik uppercase shadow-[0_0_30px_rgba(0,0,0,0.08)] text-inaqpurple
        hover:bg-inaqgold active:bg-inaqgold text-lg py-3 px-6'
            size='lg'
            backgroundColor='#660099!important'
            color='#eaeaea'
            title={cta.buttonLabel}
          />
          <p className='mt-8 xs:mt-12 xs:mb-12 xs:px-16 text-base leading-8 md:leading-10 text-gray-300 max-w-3xl mx-auto xs:text-[14px]'>
            Môžete nám tiež zavolať na{" "}
            <ProtectedPhone
              phone={INAQ_CONTACTS.PHONE_TEL}
              display={INAQ_CONTACTS.PHONE_DISPLAY}
              className='font-bold hover:underline'
            />{" "}
            alebo napísať na{" "}
            <ProtectedEmail
              email={INAQ_CONTACTS.MARKETING_EMAIL}
              className='font-bold hover:underline'
            />
          </p>
        </div>
      </ParticleSection>
    </Suspense>
  </m.section>
);

export default RepeatCTA;
